// 新聞元件 ( 新聞列表、搜尋列表、專欄內頁列表 )
import { useRouter } from 'next/navigation';
import dayjs from 'dayjs';
import Image from 'next/image';
import Tag from '../layout/Tag'; // tag 標籤
import Link from 'next/link';

const NewsComponent = ({ t, news, location = null }) => {
    const router = useRouter();

    const time = dayjs(location === 'project' ? news?.modifiedTime : news?.displayTime).format(
        'YYYY.MM.DD'
    );

    // 點擊分類跳轉
    const handleCategoryClick = (e) => {
        e.preventDefault();
        router.push(`/news?category=${news?.category}`);
    };

    return (
        <div className="flex-shrink-0 space-y-[18px] relative z-[1]">
            <Link
                href={`/news/${news?.slug}`}
                className="space-y-[18px] group"
                prefetch={location !== 'project'}
            >
                <div className="img-box aspect-[368/233] w-full trans rounded-[4px] overflow-hidden">
                    {/* 新聞圖片 */}
                    <Image
                        loading={location === 'list' ? 'eager' : undefined}
                        className="hover-img"
                        width={368}
                        height={233}
                        src={news?.imageFb || news?.image || '/images/news/default_related.svg'}
                        alt={news?.title + (news?.brief || '')}
                        sizes="(max-width: 599px) 75vw, (max-width: 1199px) 275px, 305px"
                    />
                </div>

                {/* 分類＋時間 */}
                <p className="text-pale text-btn1b space-x-[12px]">
                    <span className="text-pale text-btn1b" onClick={handleCategoryClick}>
                        {t(news?.category?.toUpperCase())}
                    </span>
                    <span className="text-btn1 text-black3 inline-block">
                        {/* 專題時間顯示不一樣 */}
                        {time}
                    </span>
                </p>

                {/* 標題 */}
                <h2 className="text-btn5b text-black hover-text line-clamp-2">{news?.title}</h2>
            </Link>

            {/* tag 標籤 */}
            <div className="flex items-center justify-start flex-wrap gap-x-[6px] gap-y-[12px]">
                {news?.tags?.length > 0
                    ? news?.tags?.map((v, i) => (
                          <Tag key={'search-news-tag' + v + i} tag={v}>
                              {v}
                          </Tag>
                      ))
                    : news?.hashtags?.split(',')?.map((v, i) => (
                          <Tag key={'search-news-tag' + v + i} tag={v}>
                              {v}
                          </Tag>
                      ))}
            </div>
        </div>
    );
};

export default NewsComponent;
